import router from '@/router'
import store from '@/store'

import { isAdmin, isManager, isTokenCheck } from '@/api/login'

import { getUrToken, getPuxToken } from '@/utils/auth'



// 토큰 검사 제외할 페이지
const whiteList = [
    '/',
    '/login',
    '/join',
    '/authConfirm',
    '/signup',
    '/contractLock',
    '/dongwonLockDetail',
    '/sajoLockDetail',
    '/v2/contractLock',
    '/v2/dongwonLockDetail',
    '/v2/sajoLockDetail',
    '/event',
    '/paymentInfo',
    '/changeMember',
    '/usrSwJoinAuthConfirm',
    '/scanContractNum',
    '/voucher',
    '/voucherLog'
]

const adminList = [
    // '/contract/officeContract',
    // '/contract/officeContractList'
]

const ManagerList = [
    '/contract/officeContract',
    '/contract/officeContractList'
]

router.beforeEach((to, from, next) => {
    if (getUrToken()) {
        if (to.path === '/login') {
            next({ path: '/main' })
        } else if (to.path.indexOf('/scanContractNum/') !== -1) {
            var contractNum = to.path.substring(to.path.lastIndexOf('/') + 1)
            next({ path: '/scanContractNum', query: { contractNum: contractNum } })
        } else if (whiteList.indexOf(to.path) !== -1) {
            next()
        } else if (to.path === '/lockDetail') {
            next()
                // } else if (to.path === '/scanContractNum') {
                //   next()
        } else {
            if (getPuxToken()) {
                if (!store.state.user.userid) {
                    store.dispatch('setUrdata')
                    if (store.state.user.userid.indexOf('NonMember') > -1) {
                        store.dispatch('LogOut').then(() => {
                            next('/login')
                        })
                    }
                    isTokenCheck(store.state.user).then(response => {
                        // store.dispatch('updateOrgdata', response.rdata.getToken)
                        if (response.rdata.getToken !== null) {
                            store.dispatch('updateOrgdata', response.rdata.getToken)
                        } else {
                            store.dispatch('updateOrgdata', '')
                        }
                        if (adminList.indexOf(to.path) !== -1) {
                            if (from.path === '/') {
                                next()
                            } else {
                                isAdmin(store.state.user).then(response => {
                                    if (response.rdata.rcode === 20000) {
                                        if (response.rdata.isAdmin) {
                                            next()
                                        } else {
                                            // MessageBox.alert('관리자 권한이 필요한 기능입니다. 기업설정 정보를 확인하세요.', '기업 설정 정보', {
                                            //    confirmButtonText: '확인',
                                            //    callback: action => {
                                            //        next({ path: '/contract/newprovision' })
                                            //   }
                                            // })
                                        }
                                    } else {
                                        // MessageBox.alert('관리자 권한이 필요한 기능입니다. 기업설정 정보를 확인하세요.', '기업 설정 정보', {
                                        //    confirmButtonText: '확인',
                                        //    callback: action => {
                                        //        next({ path: '/contract/newprovision' })
                                        //    }
                                        // })
                                    }
                                }).catch(e => {
                                    // MessageBox.alert('계정정보를 확인 할 수 없습니다. 새로고침 후 다시 이용하여 주세요.', '기업 설정 정보', {
                                    //    confirmButtonText: '확인',
                                    //    callback: action => {
                                    //        next({ path: '/contract/newprovision' })
                                    //    }
                                    // })
                                })
                            }
                        } else if (ManagerList.indexOf(to.path) !== -1) {
                            if (from.path === '/') {
                                next()
                            } else {
                                isManager(store.state.user).then(response => {
                                    if (response.rdata.rcode === 20000) {
                                        if (response.rdata.isManager) {
                                            next()
                                        } else {
                                            // MessageBox.alert('기업 회원 전용 메뉴 입니다. 기업설정 정보를 확인하세요.', '기업 설정 정보', {
                                            //    confirmButtonText: '확인',
                                            //    callback: action => {
                                            //        next({ path: '/settings/orgConfig' })
                                            //    }
                                            // })
                                        }
                                    } else {
                                        // MessageBox.alert('기업 회원 전용 메뉴 입니다. 기업설정 정보를 확인하세요.', '기업 설정 정보', {
                                        //    confirmButtonText: '확인',
                                        //    callback: action => {
                                        //         next({ path: '/settings/orgConfig' })
                                        //    }
                                        // })
                                    }
                                }).catch(e => {
                                    // MessageBox.alert('계정정보를 확인 할 수 없습니다. 새로고침 후 다시 이용하여 주세요.', '기업 설정 정보', {
                                    //    confirmButtonText: '확인',
                                    //    callback: action => {
                                    //        next({ path: '/settings/orgConfig' })
                                    //    }
                                    // })
                                })
                            }
                        } else {
                            next()
                        }
                    })
                } else {
                    if (store.state.user.userid.indexOf('NonMember') > -1) {
                        store.dispatch('LogOut').then(() => {
                            next('/login')
                        })
                    } else {
                        next()
                    }

                }
            } else {
                next('/login')
            }
        }
    } else {
        if (to.path.indexOf('/scanContractNum/') !== -1) {
            var contractNum = to.path.substring(to.path.lastIndexOf('/') + 1)
            next({ path: '/scanContractNum', query: { contractNum: contractNum } })
        } else if (whiteList.indexOf(to.path) !== -1) {
            next()
        } else {
            if (to.query.intent !== undefined && to.query.intent === 'true') {
                // next page 경로가 있는 경우의 로그인
                next({ path: '/login', query: to.query })
            } else {
                // 일반 로그인
                next('/login')
            }
        }
    }
})